import styled from "@emotion/styled";
import colors from "styles/colors";
import { MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StylesDirectoryHeaderContentComponent = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;

  h1 {
    max-width: 60vw;
    font-size: 4vw;
    font-weight: 400;
    color: ${colors["white"]};
    margin-bottom: 24px;
    letter-spacing: 1.3px;
    max-width: 50vw;
  }

  h2 {
    max-width: 60vw;
    font-size: 1.3vw;
    line-height: 34px;
    font-weight: 100;
    letter-spacing: 1.3px;
    color: ${colors["white"]};
    margin-bottom: 24px;
    max-width: 50vw;
  }

  .search-input-wrapper {
    position: relative;
    height: 40px;
    width: 300px;

    input {
      height: 100%;
      width: 100%;

      padding: 0 48px 0 16px;
      border-radius: 24px;
      outline: none;
      border: 0;

      font-size: 0.8125rem;
    }

    .search-icon-container {
      position: absolute;
      pointer-events: none;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    h1 {
      font-size: 2.25rem;
      max-width: 100vw;
    }

    h2 {
      font-size: 1rem;
      max-width: 100vw;
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    h1 {
      font-size: 3.375rem;
      max-width: 100%;
      padding: 0 16px;
    }

    h2 {
      max-width: 100%;
      padding: 0 16px;
    }
  }
`;
